const { NodeVisualiser } = require("@/visualisation/graphs/waitingTimeAnimations/nodeVisuals.js");
const { LineVisualiser } = require("@/visualisation/graphs/waitingTimeAnimations/resourceLineVisuals.js");
const { ProjectVisualiser } = require("@/visualisation/graphs/waitingTimeAnimations/projectVisuals.js");
const {getResourceNodePositions, getProjectNodePositions} = require("@/visualisation/graphs/waitingTimeAnimations/nodePositions.js");

class WaitingTimeVisualiser {
    constructor(state, svg, defs, resourceGroups) {
        this.svg = svg;
        this.defs = defs;
        this.state = state;
        
        this.resourceGroups = Object.values(resourceGroups);
        this.resourceGroups.push({ name: "Gray", color: "#808080", id: "G" });

        this.nodeVisualiser = new NodeVisualiser(this.resourceGroups);
        this.lineVisualiser = new LineVisualiser(state.simulator.params.graphShape, this.resourceGroups, state.SimInfo.SimName);
        this.projectVisualiser = new ProjectVisualiser(state.simulator.params.graphShape, this.resourceGroups);

        this.initialiseSVG();
        this.initialiseElements(resourceGroups);
    }

    initialiseSVG() {
        const width = 1200;
        const height = 800;

        this.svg.attr("width", width).attr("height", height);
        this.svg// Responsive SVG needs these 2 attributes and no width and height attr.
        // Class to make it responsive.
        this.defs = this.svg.append("defs");

        const mainGroup = this.svg
            .append("g")
            .attr("id", "main")
            .attr("transform", "translate(" + width / 2 + "," + height / 2 + ")");

        // Insert lines and circles groups, lines first so they are behind circles
        this.projectLineGroup = mainGroup.append("g").attr("id", "projects");
        this.resourceLinesGroup = mainGroup.append("g").attr("id", "resourceLines");
        this.resourceTransitionLinesGroup = mainGroup.append("g").attr("id", "transitionLines");
        this.transitionCirclesGroup = mainGroup.append("g").attr("id", "transitionCircles");
        this.circlesGroup = mainGroup.append("g").attr("id", "circles");
        this.projectGroup = mainGroup.append("g").attr("id", "projects");
    }

    initialiseElements() {
        var resourcePositions = getResourceNodePositions(this.state.simulator.params, this.resourceGroups);
        var projectPositions = getProjectNodePositions (this.state.simulator.params);
        this.nodeVisualiser.createResourceGroupNodes(this.projectGroup, resourcePositions)
        this.lineVisualiser.createAllLines(this.resourceLinesGroup, this.resourceTransitionLinesGroup, this.transitionCirclesGroup, this.defs, resourcePositions, projectPositions);
        this.projectVisualiser.createProjectNodes(this.projectGroup, projectPositions);
    }       

    updateVisuals(newMetrics, withoutCircles) {
        this.nodeVisualiser.updateNodes(newMetrics);
        this.lineVisualiser.updateLines(newMetrics, withoutCircles);
    }

}

module.exports = { WaitingTimeVisualiser }